<template>
  <div class="ptc_container">
    <div class="join_contant">
      <h3 class="login_tit">회원가입</h3>
      <!-- 1. 약관동의 -->
      <div class="section1" v-show="this.currentStep === 1">
        <ul class="sign-up-step">
          <li class="on"><span>1. 약관동의</span></li>
          <li><span>2. 정보입력</span></li>
          <li><span>3. 가입완료</span></li>
        </ul>
        <div class="terms">
          <ul class="terms">
            <li class="collapsible all">
              <div class="title">
                    <span class="ag-chk all">
                        <input type="checkbox" name="allChk" id="allChk" v-model="allCheckFlag" @click="allCheck"/>
                        <label for="allChk">모든 약관에 동의합니다.</label>
                    </span>
              </div>
            </li>
            <li class="collapsible">
              <div class="title">
                    <span class="ag-chk">
                        <input type="checkbox" name="ag-chk2" id="ag-chk2" v-model="agreeIdList.TERM.checkFlag"/>
                        <label for="ag-chk2">허브 플랫폼 이용약관<em>(필수)</em></label>
                    </span>
                <a href="#none" :class="{'selected': agreeIdList.TERM.collapseFlag}" @click="toggleCollapse(`TERM`)"
                   v-b-toggle.section1-content></a>
              </div>
              <b-collapse id="section1-content">
                <div class="ag-content">
                  <div class="scroll-custom">
                    <h6>{{ agreeIdList.TERM.scrollContent.title }}</h6>
                    <p v-html='agreeIdList.TERM.scrollContent.content'></p>
                  </div>
                </div>
              </b-collapse>
            </li>
            <li class="collapsible">
              <div class="title">
                          <span class="ag-chk">
                              <input type="checkbox" name="ag-chk1" id="ag-chk1"
                                     v-model="agreeIdList.PRIVACY.checkFlag"/>
                              <label for="ag-chk1">개인정보 수집 및 이용 동의서<em>(필수)</em></label>
                          </span>
                <a href="#none" :class="{'selected': agreeIdList.PRIVACY.collapseFlag}"
                   @click="toggleCollapse(`PRIVACY`)" v-b-toggle.section2-content></a>
              </div>
              <b-collapse id="section2-content">
                <div class="ag-content">
                  <div class="scroll-custom">
                    <h6>{{ agreeIdList.PRIVACY.scrollContent.title }}</h6>
                    <p v-html='agreeIdList.PRIVACY.scrollContent.content'></p>
                  </div>
                </div>
              </b-collapse>
            </li>
            <li class="collapsible">
              <div class="title">
                  <span class="ag-chk">
                      <input type="checkbox" name="ag-chk3" id="ag-chk3" v-model="agreeIdList.AGE.checkFlag"/>
                      <label for="ag-chk3">만 14세 이상입니다.<em>(필수)</em></label>
                  </span>
              </div>
            </li>
          </ul>
        </div>

        <div class="bottom_area">
          <ul class="column col_2">
            <li>
              <a href="#none" @click="step(-1)" class="btm_btn">취소</a>
            </li>
            <li>
              <a href="#none" @click="step(1)" class="btm_btn bk">다음</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- 2. 정보입력 -->
      <div class="section2" v-show="this.currentStep === 2">
        <ul class="sign-up-step">
          <li class="on"><span>1. 약관동의</span></li>
          <li class="on"><span>2. 정보입력</span></li>
          <li><span>3. 가입완료</span></li>
        </ul>
<!--        기본정보-->
        <h3 class="form_tit">기본 정보</h3>

        <div class="form_cont">
          <ul class="column col_2">
            <li>
              <div class="label_txt">
                <span>아이디<em>*</em></span>
              </div>
              <div class="column_input">
                <ul class="inp_column btn">
                  <li>
                    <input type="text" name="loginId" maxlength="80"
                           :class="input.loginId.validMessage != null && input.loginId.validMessage != ''? `validation_error` : ``"
                           @input="inputListener" @keydown="keydownListener"/>
                    <p v-show="input.loginId.validMessage != null && input.loginId.validMessage != ''"
                       class="validation_text">{{ input.loginId.validMessage }}</p>
                  </li>
                  <li class="col_btn">
                    <button type="button" class="inp_btn" @click="duplicateCheckId" v-bind:disabled="duplicateCheck">중복확인</button>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <div class="label_txt">
                <span>이름<em>*</em></span>
              </div>
              <div class="column_input">
                <input type="text" name="name"
                       :class="input.name.validMessage != null && input.name.validMessage != ''? `validation_error` : ``"
                       v-model="input.name.value"/>
                <!--                <input type="text" name="name"
                                       :class="input.name.validMessage != null && input.name.validMessage != ''? `validation_error` : ``"
                                       @input="inputListener" @keydown="keydownListener" readonly/>-->
                <p v-show="input.name.validMessage != null && input.name.validMessage != ''" class="validation_text">
                  {{ input.name.validMessage }}</p>
              </div>
            </li>
          </ul>
          <ul class="column col_2">
            <li>
              <div class="label_txt">
                <span>비밀번호<em>*</em></span>
              </div>
              <div class="column_input">
                <input type="password" name="password" maxlength="80"
                       :class="input.password.validMessage != null && input.password.validMessage != ''? `validation_error` : ``"
                       @input="inputListener" @keydown="keydownListener"
                       placeholder="영문 대･소문자, 숫자, 특수문자를 포함, 최소 8자 이상."/>
                <div class="pw_danger_area">
                  <div class="pw_danger_bar_wrap">
                    <!--
                        안전도에 따라 pw_danger_bar에 active 클래스 추가
                    -->
                    <div class="pw_danger_bar weak"
                         :class="passwordStrength == 0 || passwordStrength == 1? `active` : ``"
                    ><span></span></div>
                    <div class="pw_danger_bar medium"
                         :class="passwordStrength == 2? `active` : ``"
                    ><span></span></div>
                    <div class="pw_danger_bar strong"
                         :class="passwordStrength == 3? `active` : ``"
                    ><span></span></div>
                  </div>
                  <div class="pw_danger_txt">
                    <p v-if="passwordStrength == 0 || passwordStrength == 1" class="danger_weak">Weak</p>
                    <p v-else-if="passwordStrength == 2" class="danger_medium">Medium</p>
                    <p v-else class="danger_strong">Strong</p>
                  </div>
                </div>
                <p v-show="input.password.validMessage != null && input.password.validMessage != ''"
                   class="validation_text">{{ input.password.validMessage }}</p>
              </div>
            </li>
            <li>
              <div class="label_txt">
                <span>비밀번호 확인<em>*</em></span>
              </div>
              <div class="column_input">
                <input type="password" name="passwordConfirm" maxlength="80"
                       :class="input.passwordConfirm.validMessage != null && input.passwordConfirm.validMessage != ''? `validation_error` : ``"
                       @input="inputListener" @keydown="keydownListener"
                       placeholder="영문 대･소문자, 숫자, 특수문자를 포함, 최소 8자 이상."/>
                <p v-show="input.passwordConfirm.validMessage != null && input.passwordConfirm.validMessage != ''"
                   class="validation_text">{{ input.passwordConfirm.validMessage }}</p>
              </div>
            </li>
          </ul>
          <ul class="column col_2">
            <li>
              <div class="label_txt">
                <span>소속(직장명)<em>*</em></span>
              </div>
              <div class="column_input">
                <select
                    v-model="input.companyCode.value"
                    :style="{borderColor :input.companyCode.validMessage != null && input.companyCode.validMessage != ''? 'red':''}"
                >
                  <option v-for="(opt,index) in sortedCompanyList" :key="index" :value="opt.value"
                    :selected="index == 0? true:false"
                  >
                    {{opt.text}}
                  </option>
               </select>
                <p v-show="input.companyCode.validMessage != null && input.companyCode.validMessage != ''"
                   class="validation_text">{{ input.companyCode.validMessage }}</p>
              </div>
            </li>
            <li>
              <div class="label_txt">
                <span>직책<em>*</em></span>
              </div>
              <div class="column_input">
                <input type="text" name="position" maxlength="80"
                       :class="input.position.validMessage != null && input.position.validMessage != ''? `validation_error` : ``"
                       @input="inputListener" @keydown="keydownListener"
                       placeholder="직책을 입력하세요."/>
                <p v-show="input.position.validMessage != null && input.position.validMessage != ''"
                   class="validation_text">{{ input.position.validMessage }}</p>
              </div>
            </li>
          </ul>
          <ul class="column col_2">
            <li>
              <div class="label_txt">
                <span>직장전화번호<em>*</em></span>
              </div>
              <div class="column_input">
                <input type="text" name="companyPhone" maxlength="80"
                       :class="input.companyPhone.validMessage != null && input.companyPhone.validMessage != ''? `validation_error` : ``"
                       @input="inputListener" @keydown="keydownListener"
                       placeholder="직장전화번호를 입력하세요."/>
                <p v-show="input.companyPhone.validMessage != null && input.companyPhone.validMessage != ''"
                   class="validation_text">{{ input.companyPhone.validMessage }}</p>
              </div>
            </li>
            <li>
              <div class="label_txt">
                <span>휴대전화<em>*</em></span>
              </div>
              <div class="column_input">
                <input type="text" name="mobile" maxlength="80"
                       :class="input.mobile.validMessage != null && input.mobile.validMessage != ''? `validation_error` : ``"
                       @input="inputListener" @keydown="keydownListener"
                       placeholder="휴대전화를 입력하세요."/>
                <p v-show="input.mobile.validMessage != null && input.mobile.validMessage != ''"
                   class="validation_text">{{ input.mobile.validMessage }}</p>
              </div>
            </li>
          </ul>
          <ul class="column col_2">
            <li>
              <div class="label_txt">
                <span>팩스</span>
              </div>
              <div class="column_input">
                <input type="text" name="fax" maxlength="80"
                       :class="input.fax.validMessage != null && input.fax.validMessage != ''? `validation_error` : ``"
                       @input="inputListener" @keydown="keydownListener"
                       placeholder="팩스번호를 입력하세요."/>
                <p v-show="input.fax.validMessage != null && input.fax.validMessage != ''"
                   class="validation_text">{{ input.fax.validMessage }}</p>
              </div>
            </li>
          </ul>
        </div>
        <!--이메일인증-->
        <h3 class="form_tit">이메일 인증</h3>

        <div class="form_cont">
          <ul class="column col_2">
            <li>
              <div class="label_txt">
                <span>이메일<em>*</em></span>
              </div>
              <div class="column_input">
                <ul class="inp_column btn">
                  <li>
                    <input type="text" name="email" maxlength="80"
                           :class="input.email.validMessage != null && input.email.validMessage != ''? `validation_error` : ``"
                           @input="inputListener" @keydown="keydownListener" v-bind:readonly="emailAuth.flag"/>
                    <p v-show="input.email.validMessage != null && input.email.validMessage != ''"
                       class="validation_text">
                      {{ input.email.validMessage }}
                    </p>
                  </li>
                  <li class="col_btn">
                    <button type="button" class="inp_btn" @click="sendEmailAuthCode" v-bind:disabled="emailAuth.flag">
                      <span v-if="!emailAuth.sendYn">인증번호 발송</span>
                      <span v-else>인증번호 재발송</span>
                    </button>
                  </li>
                </ul>
              </div>
            </li>
            <li v-show="emailAuth.sendYn">
              <div class="label_txt">
                <span>인증번호<em>*</em></span>
              </div>
              <div class="column_input">
                <ul class="inp_column btn">
                  <li>
                    <input type="text" maxlength="80"
                           :class="emailAuth.validMessage != null && emailAuth.validMessage != ''? `validation_error` : ``"
                           v-model="emailAuth.value" v-bind:readonly="emailAuth.flag"/>
                    <span style="color: red">{{ displayTime }}</span>
                    <p v-show="emailAuth.validMessage != null && emailAuth.validMessage != ''" class="validation_text">
                      {{ emailAuth.validMessage }}
                    </p>
                  </li>
                  <li class="col_btn">
                    <button type="button" class="inp_btn" @click="verificationEmailAuthCode" v-bind:disabled="emailAuth.flag">
                      인증번호 확인
                    </button>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>

        <div class="bottom_area">
          <ul class="column col_2">
            <li>
              <a href="#none" @click="step(-1)" class="btm_btn">뒤로</a>
            </li>
            <li>
              <a href="#none" @click="step(1)" class="btm_btn bk">다음</a>
            </li>
          </ul>
        </div>

      </div>

      <!-- 3. 가입완료 -->
      <div class="section3" v-show="this.currentStep === 3">
        <ul class="sign-up-step">
          <li class="on"><span>1. 약관동의</span></li>
          <li class="on"><span>2. 정보입력</span></li>
          <li class="on"><span>3. 가입완료</span></li>
        </ul>
        <!-- 일반회원가입 -->
        <div>
          <div class="member_complete space">
            <h3>회원가입을 완료했습니다.</h3>
            <p>입력하신 정보로 회원가입을 완료했습니다. <br/>입력하신 계정 정보로 로그인 해 주세요.</p>
          </div>

          <div class="bottom_area">
            <ul class="column col_1">
<!--              <li>
                <a href="#none" class="btm_btn" @click="registerConfirm">공정도 관리자 신청</a>
              </li>-->
              <li>
                <a href="#none" class="btm_btn bk" @click="$router.push(`/account/login`);">로그인</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Loading :visible="loading"></Loading>
  </div>
</template>

<script>
import Loading from '@common/loading'
import {createNamespacedHelpers} from 'vuex';
const Hub = createNamespacedHelpers('Hub');
export default {
  components: {
    Loading
  },
  computed: {
    allAgreed() {
      return this.agreeIdList.TERM.checkFlag && this.agreeIdList.PRIVACY.checkFlag && this.agreeIdList.AGE.checkFlag
    },
    sortedCompanyList() {
      const list = this.$store.getters["Hub/getOrgCodeArray"] || [];
      const sorted = [...list].sort((a, b) => a.text.localeCompare(b.text, "ko"));
      sorted.unshift({ value: "", text: "선택해주세요" });
      return sorted;
    },
  },
  watch: {
    allAgreed() {
      if (this.allAgreed === true) {
        this.allCheckFlag = true;
      } else {
        this.allCheckFlag = false;
      }
    },
  },
  async mounted() {
    await this.getTerm();
  },
  beforeDestroy() {
    console.log("beforeDestroy");
  },
  data() {
    return {
      input: {
        name: {value: null, validMessage: null},
        loginId: {value: null, validMessage: null},
        password: {value: null, validMessage: null},
        passwordConfirm: {value: null, validMessage: null},
        email: {value: null, validMessage: null},
        companyCode: {value: "", validMessage: null},
        companyPhone: {value: null, validMessage: null},
        position: {value: null, validMessage: null},
        fax: {value: null, validMessage: null},
        mobile: {value: null, validMessage: null},
      },
      emailAuth: {
        value: null,
        validMessage: null,
        sendYn: false,
        flag: false
      }, //sendYn : 메일발송여부, flag : 이메일 인증 성공여부
      allCheckFlag: false,
      agreeIdList: {
        TERM: {checkFlag: false, collapseFlag: false, scrollContent: {content: null, title: null, id: null}},
        PRIVACY: {checkFlag: false, collapseFlag: false, scrollContent: {content: null, title: null, id: null}},
        AGE: {checkFlag: false, collapseFlag: false},
      },
      currentStep: 1,
      regexCondition: {
        password: /^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W))(?=.*?[0-9])(?=.*?[#?!@$ %^&*-]).{8,50}$/,
        email: /^[a-zA-Z0-9+-\_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        loginId : /^[a-zA-Z]+[a-zA-Z0-9]{5,19}$/,
      },
      settingTime: 300, //필요한 초만큼 입력
      checkTime: null,
      displayTime: null,
      timeCheckObj: null,
      authId: null,
      loading: false,
      duplicateCheck : false,
      passwordStrength : 0,
    };
  },
  methods: {
    allFilled() {
      let flag = true;
      for (let key in this.input) {
        if(key == 'fax') continue;
        if (this.input[key].value == '' || this.input[key].value == null) {
          this.input[key].validMessage = "입력되지 않았습니다.";
          flag = false;
        } else {
          this.input[key].validMessage = null;
        }
      }
      return flag;
    },

    regexPassed(deleteTarget) {
      let flag = true;
      let regexTarget = {...this.regexCondition};
      if (deleteTarget != null && deleteTarget.length > 0) {
        for(var i = 0; i<deleteTarget.length; i++ ){
          delete regexTarget[deleteTarget[i]];
        }
      }
      for (let key in regexTarget) {
        const regex = regexTarget[key];
        if (!regex.test(this.input[key].value)) {
          if(key === "loginId"){
            this.input[key].validMessage = "영문자로 시작하는 영문자 또는 숫자 6~20자이어야합니다.";
          }else if(key === 'password'){
            this.input[key].validMessage = "영문 대･소문자, 숫자, 특수문자를 포함, 최소 8자 이상이어야 합니다.";
          }else{
            this.input[key].validMessage = "형식에 맞지않습니다.";
          }
          flag = false;
          /*alert(`key = ${key} flag = ${flag}`)*/
        } else {
          this.input[key].validMessage = null;
        }
      }
      return flag;
    },

    passwordConfirm() {
      const flag = this.input.password.value === this.input.passwordConfirm.value
      if (!flag) {
        this.input.passwordConfirm.validMessage = "비밀번호가 일치하지 않습니다.";
      }
      return flag
    },

    telCheck() {
        const reg = /^[0-9]{2,3}-[0-9]{3,4}-[0-9]{4}/;
        const flag = reg.test(this.input.mobile.value);
        if(!flag){
          this.input.mobile.validMessage = "전화번호를 형식에 맞게 입력해 주세요.(-포함)";
        }
        return flag;
    },

    inputListener(v) {
      const name = v.target.getAttribute('name');
      if(name == 'loginId') {
        this.input[name].value = v.target.value;
        this.duplicateCheck = false;
      }else if(name == 'password'){
        this.input[name].value = v.target.value;
        this.passwordStrengthCheck();
      }else{
        this.input[name].value = v.target.value;
      }
    },

    keydownListener(v) {
      const name = v.target.getAttribute('name');
      if(name == 'loginId'){
        this.input[name].value = v.target.value;
        this.duplicateCheck = false;
      }else if(name == 'password'){
        this.passwordStrengthCheck();
      }else{
        this.input[name].value = v.target.value;
      }
    },

    allCheck() {
      this.allCheckFlag = !this.allCheckFlag;
      for (let i in this.agreeIdList) {
        this.agreeIdList[i].checkFlag = this.allCheckFlag
      }
      // console.log(`this.agreeIdList = `, this.agreeIdList);
      // console.log(`this.allCheckFlag = `, this.allCheckFlag);
      // console.log(`this.allAgreed = `, this.allAgreed);
    },

    toggleCollapse(collapseId) {
      this.agreeIdList[collapseId].collapseFlag = !this.agreeIdList[collapseId].collapseFlag;
    },

    async step(num) {
      if (this.currentStep === 1 && num === -1) {
        const flag = await window.confirm(
            "지금 회원가입을 취소하시면 입력하신 정보들은 저장되지 않습니다. 그래도 취소하시겠습니까?",
            false,
            {
              okTitle: "가입 취소",
              cancelTitle: "닫기",
              okVariant:
                  "platform confirm-btn text-14 text-center py-2 px-4 mx-2 mb-2 text-nowrap",
            }
        );
        if (flag) {
          this.$router.push("/account/login");
        }
      } else if (this.currentStep === 1 && num === 1 && !this.allAgreed) {
        window.alert("<b>모든 약관에 동의해야 합니다.</b>");
        return;
      } else if (this.currentStep === 2 && num === 1) {
        if (!this.allFilled() || !this.regexPassed() || !this.passwordConfirm() || !this.telCheck()) {
          return;
        }

        if (!this.emailAuth.flag) {
          alert('이메일 인증이 필요합니다.')
          return;
        }

        if(!this.duplicateCheck){
          alert('아이디 중복확인이 필요합니다.');
          return;
        }

        const flag = await window.confirm(
            "가입하시겠습니까?",
            false,
            {
              okTitle: "가입",
              cancelTitle: "닫기",
              okVariant:
                  "platform confirm-btn text-14 text-center py-2 px-4 mx-2 mb-2 text-nowrap",
            }
        );
        if (flag) {
          try {
            const body = {
              name: this.input.name.value,
              loginId: this.input.loginId.value,
              password: this.input.password.value,
              passwordConfirm: this.input.passwordConfirm.value,
              email: this.input.email.value,
              termsAgreeIdList: [this.agreeIdList.TERM.scrollContent.id, this.agreeIdList.PRIVACY.scrollContent.id],
              companyCode : this.input.companyCode.value,
              companyPhone : this.input.companyPhone.value,
              position : this.input.position.value,
              mobile : this.input.mobile.value,
              fax : this.input.fax.value,
            };

            const data = await this.$wApi.user.signup(body, null, {
              useError: true,
            });

            if (data?.error === true) {
              window.alert(data.message);
              return;
            }
            if (data.userId) {
              this.currentStep += num;
            }
          } catch (error) {
            window.alert(error);
            return;
          }
        }
      } else {
        this.currentStep += num;
        return;
      }
    },

    async registerConfirm() {
      alert('개발중인 기능입니다.')
      return;
      const bool = await window.confirm(
          "공정도 관리자로 등록하면 공정도 작성 활동을 할 수 있습니다.<br>등록하시겠습니까?",
          false,
          {
            okTitle: "등록하기",
            okVariant:
                "platform confirm-btn text-14 text-center py-2 px-4 mx-2 mb-2 text-nowrap",
          }
      );
      if (bool) {
        alert('개발중')
        //this.$router.push("/register-application");
      }
    },

    async getTerm() {
      const agreeType = ['PRIVACY', 'TERM'];
      for (const type of agreeType) {
        const {title, content, id} = await this.$wApi.terms.get({type});
        this.agreeIdList[type].scrollContent = {
          content,
          title,
          id
        };
      }
    },

    async sendEmailAuthCode() {
      //console.log('sendEmailAuthCode 호출');
      //이메일 정규식 확인
      if (this.regexPassed(["password","loginId"])) {
        if (this.emailAuth.flag) {
          alert('이미 인증되었습니다.')
          return;
        }

        try {
          //todo 빽단에서 sendmail 시도
          const data = await this.$wApi.user.emailAuth.create({
            email: this.input.email.value,
            findFlag : false
          }, null, {
            useError: true,
          });

          if(data?.error === true){
            alert(data.message);
            return;
          }

          if (data.id) {
            this.authId = data.id;
            //메일 전송여부
            this.emailAuth.sendYn = true
            //메일 인증 시각
            this.checkTime = this.settingTime;
            //setTimeout 초기화
            if (this.timeCheckObj != null) {
              clearTimeout(this.timeCheckObj);
            }
            //메일 인증 시각 함수
            this.fnTimeCheck();
            alert("발송되었습니다.");
          }else{
            alert("발송에 실패하였습니다. 다시 시도해주세요.");
          }

        } catch (e) {
          console.log(e)
        }
      }
    },

    async verificationEmailAuthCode() {
      //console.log('verifycationEmailAuthCode 호출');
      //기입력한 메일과 현재 입력한 메일의 값이 동일한 경우만 이메일인증코드 확인절차 실행.
      if (this.emailAuth.flag) {
        alert('이미 인증되었습니다.');
        return;
      }

      try {
        //todo 빽단에서 인증절차 시도(인증코드/메일 db와 input 비교)
        const result = await this.$wApi.user.emailAuth.verification({
          id: this.authId,
          emailAuthCode: this.emailAuth.value,
          email: this.input.email.value
        }, null, {
          useError: true,
        });

        if (result?.error === true) {
          alert(result.message);
          return;
        }
        if (result) {
          alert('인증이 완료되었습니다.');
          this.emailAuth.flag = true;
          if (this.timeCheckObj != null) {
            clearTimeout(this.timeCheckObj);
            this.displayTime = "";
          }
        }else{
          alert('인증이 실패되었습니다. \n 다시 시도해주세요.');
        }

      } catch (e) {
        console.log(e)
        alert('인증이 실패되었습니다. \n 다시 시도해주세요.');
      }
    },

    fnTimeCheck() {
      if (this.checkTime > 0) {
        const m = Math.floor(this.checkTime / 60);
        let s = this.checkTime % 60;
        if (s < 10) s = "0" + s;
        const time = m + ":" + s;
        this.displayTime = time
        this.checkTime--;
        this.timeCheckObj = setTimeout(this.fnTimeCheck, 1000);
      } else {
        this.displayTime = "0:00";
        this.emailAuth.sendYn = false;
        this.emailAuth.flag = false;
        this.emailAuth.value = null;
        this.authId = null;
        alert("입력시간을 초과했습니다.");
      }
    },

    async duplicateCheckId(){
      if(this.input.loginId.value !== null && this.input.loginId.value !== ""){
        if(!this.regexPassed(['password','email'])){
          return;
        }
        this.input['loginId'].validMessage = null;
      }else{
        this.input['loginId'].validMessage = "입력되지 않았습니다.";
        return;
      }

      const result = await this.$wApi.user.duplicateCheckId({
        loginId : this.input.loginId.value
      },null,{useError: true,});

      if (result?.error === true) {
        alert(result.message);
        this.input['loginId'].validMessage = "사용불가능한 아이디입니다.";
        this.duplicateCheck = false;
        return;
      }else if(result){
        alert("사용가능한 아이디입니다.");
        this.input['loginId'].validMessage = null;
        this.duplicateCheck = true;
      }else{
        this.duplicateCheck = false;
      }
    },
    passwordStrengthCheck() {
      if(!this.input.password.value){
        return;
      }

      let strength = 0
      const regexes = [
        /[a-z]+/,
        /[0-9]+/,
        /[$@#&!]+/,
      ]

      regexes.forEach((regex, index) => {
        let password = this.input.password.value;
        strength += password.match(regex) ? 1 : 0
      })

      this.passwordStrength = strength
    },
  }, //method
};
</script>
<style>
</style>
